import React from 'react'

import CustomIcon from "../../../../../core/gd-components/icons/common/custom-icon/custom-icon"
import {EmojiDict} from "../../../../../core/gd/const/item-icon/emoji/emoji"
import Emoji from "../../../../../core/gd-components/icons/common/emoji/emoji"
import {ItemIconSize} from "../../../../../core/gd-components/icons/@const"

type Props = {
    iconClass?      : string | false
    projectIcon?    : string
    color?          : number
}

// const debug = "NavigationMenuItemInput_IconComponent"
const debug = false

export default function NavigationMenuItemInput_IconComponent(props: Props) {

    // sessionProject.projectIcon = 'url:https://www.svgrepo.com/show/530597/hat.svg'
    if (props.projectIcon?.substring(0,4)==='url:') {
        return <CustomIcon className    = "icon"
                           size         = {ItemIconSize.SIZE_18}
                           icon         = {props.projectIcon}/>
    }

    // EMOJI CASE
    if (props.projectIcon && !!EmojiDict[props.projectIcon as keyof {}]) {
        return <Emoji className = "ui5-project-icon icon"
                      size      = {ItemIconSize.SIZE_15}
                      name      = {props.projectIcon}/>
    }

    const iconClasses = Classes("gd-ui-project-icon ui5-project-icon fs-{0} icon".f(ItemIconSize.SIZE_15), props.iconClass, {
        ['gd-c-font-'+props.color]: !!props.color
    })
    return <div className={iconClasses}/>
}